export const MAX_TIMEOUT = 1500; // timeouts longer than this value won't be attached to a context
export const MAX_OBSERVER_CALLBACK_DELAY = 300; // observers triggered after this delay won't be attached to the initial context
